import styled from "styled-components";

export default {
  H1: styled.div`
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: -0.25px;
  `,

  H2: styled.div`
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: -0.25px;
  `,

  H3: styled.div`
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.25px;
  `,

  H4: styled.div`
    font-weight: 700;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: -0.25px;
  `,
  H5: styled.div`
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.25px;
  `,
  H6: styled.div`
    font-weight: 700;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: -0.25px;
  `,
  Body1: styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.25px;
  `,
  Body2: styled.div`
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: -0.25px;
  `,
  Blockquote: styled.div`
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.25px;
  `,
  Badge: styled.div`
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;
    letter-spacing: -0.25px;
  `,
};
